module.exports = __webpack_public_path__ + "static/media/despacho.597a1cb2.png";